import axios from 'axios';
import {
	ZTP_DETAILS_GET,
	ZTP_DETAILS_GET_FAIL,
	ZTP_DETAILS_SUCCESS
} from '../constants/userConstants';

import {
  ENDPOINT_URL,
  GET_ZTP__BANNER_DETAILS,
} from '../constants/commonConstants';

export const getBannerZTPDetails = (getdata) => async (dispatch) => {
    try {
        dispatch({ type: ZTP_DETAILS_GET });

        const config = {
            method: 'get',
            url: ENDPOINT_URL + GET_ZTP__BANNER_DETAILS,
            data: getdata,
        };

        const { data } = await axios.request(config);

        if (data) {
            dispatch({
                type: ZTP_DETAILS_SUCCESS,
                payload: data.data,
            });

            // Return the data to the caller
            return data;
        } else {
            dispatch({
                type: ZTP_DETAILS_SUCCESS,
                payload: {},
            });

            return {};
        }
    } catch (error) {
        dispatch({
            type: ZTP_DETAILS_GET_FAIL,
            payload: error.message || 'Failed to download data',
        });

        throw error;
    }
};
